module.exports = __webpack_public_path__ + "a77e258bfdb06c2d32ae38159bb52c07.jpg";